module.exports = __webpack_public_path__ + "static/img/bg-1.e1f7b240.png";